import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";

class SSOTokenApiDefinition extends ApiDefinition {
  constructor() {
    super("/jwt");
  }

  async getSSOToken(): Promise<APIResponse<string>> {
    return this.get("sso-token");
  }
}

const SSOTokenApi = new SSOTokenApiDefinition();
export default SSOTokenApi;
